import React from "react"

export function HeroImage() {
  return (
    <div className="w-[45%] flex items-end justify-end max-lg:w-full max-lg:h-auto max-lg:justify-center max-lg:bg-gradient-to-b max-lg:from-sailcloth max-lg:to-horizon">
      <img
        src="/images/hero-image-v2.webp"
        srcSet="/images/hero-image-mobile.webp 824w, /images/hero-image-v2.webp 1382w"
        sizes="(max-width: 1023px) 100vw, 45vw"
        alt="Elderly man using GrandPad tablet for connected care"
        className="h-auto w-[115%] max-w-none object-contain object-bottom object-right max-lg:object-center max-lg:max-w-full max-lg:w-full"
        width={1382}
        height={1326}
        fetchPriority="high"
        decoding="async"
      />
    </div>
  )
}
